const SectionCont3 = () => {
	return (
		<section className="sub-content cont3">
			<div className="sub-inner">
				<div className="sub-title black">
					<strong className="title black">브랜드 아이덴티티</strong>
				</div>
				<div className="identity-box">
					<ul className="identity-title">
						<li>
							<p className="align-center">
								하나로 통합된 <br />
								All-in-One 플랫폼
							</p>
						</li>
						<li>
							<p className="align-center">
								Stella, <br />
								From Start to Scale
							</p>
						</li>
						<li>
							<p className="align-center">
								데이터 기반의 <br />
								스마트한 경영 지원
							</p>
						</li>
					</ul>
					<ul className="identity-list">
						<li>
							<div className="desc-group">
								<p className="title">하나로 통합된 All-in-One 플랫폼</p>
								<p className="desc">
									<span className="font-bold">
										재무 관리, 세무 처리, 문서 발급, 데이터 분석 등 다양한 업무를 단일 플랫폼에서 관리
									</span>
									하여, 여러 시스템을 오가며 시간을 낭비할 필요가 없습니다. <br />
									특히 모듈형 ERP 설계로 손쉬운 확장이 가능해, <br />
									필요한 솔루션을 자유롭게 연동하고 미래 성장을 <br />
									준비할 수 있습니다.
								</p>
							</div>
						</li>
						<li>
							<div className="desc-group">
								<p className="title">Stella, From Start to Scale</p>
								<p className="desc">
									기업의 첫걸음부터 안정적인 성장을 위해, Stella는 <br />
									<span className="font-bold">국내 최대 회계법인 삼일회계법인</span>과&nbsp;
									<span className="font-bold">IT 전문기업 핑거</span>의 <br />
									<span className="font-bold">노하우가 결합된 혁신적 엔터프라이즈 플랫폼</span>입니다. <br />
									AI 기반 자동화와 모듈형 ERP 구조를 통해 <br />
									비효율적인 업무 환경을 혁신하고, 스타트업의 <br />
									운영 효율성을 극대화합니다.
								</p>
							</div>
						</li>
						<li>
							<div className="desc-group">
								<p className="title">데이터 기반의 스마트한 경영 지원</p>
								<p className="desc">
									Stella는 스크래핑 기술과 AI 기반 입력 기능을 통해 <br />
									기업의 데이터를 자동으로 수집·분석하고, <br />
									Connected Data Hub에서 손 쉽게 활용할 수 있도록 <br />
									지원합니다. <br />
									<span className="font-bold">
										재무 분석 : 경영 상태를 실시간으로 파악하고 대응 <br />
										비즈니스 인사이트 : 데이터 기반의 전략적 의사결정 도출
									</span>
								</p>
							</div>
						</li>
					</ul>
					<div className="text-box">
						<p>Stella는 단순한 ERP 시스템을 넘어, 기업의 시작·성장·미래를 함께 이끄는 든든한 성공의 나침반입니다.</p>
					</div>
				</div>
			</div>
		</section>
	);
};

export default SectionCont3;
